<!--
 * @Description: 角色详情页专用布局
 * PC端：显示 AppHeader 和 Sidebar（完整的 default layout）
 * 移动端：隐藏 AppHeader，全屏显示内容
-->
<template>
    <div class="character-detail-layout">
        <!-- PC 端显示 AppHeader 和 Sidebar -->
        <app-header class="pc-header"></app-header>
        <app-sidebar class="pc-sidebar"></app-sidebar>
        
        <!-- 主内容区 -->
        <main 
            class="character-main bg-default"
            :class="[
                appStore.sidebarCollapsed ? 'sidebar-collapsed' : 'sidebar-expanded'
            ]"
        >
            <slot />
        </main>
    </div>
</template>

<script setup lang="ts">
import { useAppStore } from '@/stores/app'

const appStore = useAppStore()
</script>

<style scoped lang="less">
.character-detail-layout {
    min-height: 100vh;
    background-color: var(--bg-default, #0f0f0f);
}

// PC 端样式（>= 768px）
@media (min-width: 768px) {
    .pc-header {
        display: block;
    }

    .pc-sidebar {
        display: block;
    }

    .character-main {
        min-height: calc(100vh - 52px);
        padding-top: 5px;
        padding-right: 20px;
        padding-top: 52px; // AppHeader 高度
        transition: padding-left 0.3s ease-in-out;

        &.sidebar-collapsed {
            padding-left: 92px; // 收起状态的 sidebar 宽度
        }

        &.sidebar-expanded {
            padding-left: 184px; // 展开状态的 sidebar 宽度
        }
    }
}

// 移动端样式（< 768px）
@media (max-width: 767px) {
    .pc-header {
        display: none; // 移动端隐藏 AppHeader
    }

    .pc-sidebar {
        display: none; // 移动端隐藏 Sidebar
    }

    .character-main {
        padding: 0;
        min-height: 100vh;
        width: 100%;
    }
}
</style>

